import { colors, setCssVar } from 'quasar';
const { getPaletteColor } = colors;

function setBrand(brand: string) {

  // Confused Branding
  if (brand === 'Default') {
    setCssVar('primary', '#6905F2');
    setCssVar('accent', '#2C203D');
    setCssVar('secondary', '#EBA044');
    setCssVar('dark', '#484152');
    setCssVar('positive', '#05875F');
    setCssVar('negative', getPaletteColor('brick-red'));
    setCssVar('info', getPaletteColor('blue'));
    setCssVar('warning', getPaletteColor('fiesta-yellow'));
    setCssVar('shadow-color', getPaletteColor('chrome'));
    setCssVar('brand-dark', '#484152');
    setCssVar('brand-border', '#e2e8f0');
    setCssVar('brand-app-bg', '#F8FAFC');
    setCssVar('brand-highlight', '#ECFDF5');
  };

}

export {
  setBrand
}
